import React from 'react'
import ItemList from '../leave_plan_benefits/shared/ItemList'
import ItemView from '../leave_plan_benefits/shared/ItemView'
import ItemsListView from '../leave_plan_benefits/shared/ItemsListView'
import JustLookingModalBox from '../leave_plan_benefits/shared/JustLookingModalBox'
import WhiteLabel from '../leave_plan_benefits/shared/WhiteLabel'
import EmployeeFooter from '../EmployeeFooter'
import LeavePlanTitle from '../dashboard/LeavePlanTitle'

class PlanningGuides extends React.Component {
  constructor(props) {
    super(props)

    this.infoTexts = [
      "Add Voluntary Tasks to your LeavePlan",
      "Set reminders for important tasks",
      "Enable sharing of key LeavePlan details with your Manager and HR (you share when you're ready)"
    ]

    this.state = {
      planning_guides: props.data,
      viewMode: false,
      activeList: '',
      activeGuide: '',
      activate_leave_plan_modal: false
    }
  }

  componentDidMount() {
    const location = window.location
    if (location.hash) {
      const guide = this.state.planning_guides.filter((item) => {
        return Number(item.leave_item_id) === Number(location.hash.substring(1))
      })[0]
      window.history.replaceState({}, 'LeaveLogic', '/leave_plan_guides')
      if (guide) {
        $.getJSON(`/leave_plan_guides/${guide.id}/fetch_details`, (data) => {
          gon.company_variables = {...gon.company_variables, ...data.statutory_substitutions_options}
          this.setActiveClass(guide, data.description)
        })
      }
    }
  }

  handleBack(state) {
    window.history.pushState(state, state.guide.title, "#" + state.guide.leave_item_id)
    window.onpopstate = (event) => {
      const state = window.history.state
      const location = window.location
      if (location.hash) {
        this.setState({
          viewMode: true,
          activeGuide: state.guide,
          activeList: state.guide.id,
          description: state.description
        })
      } else {
        this.setState({
          viewMode: false,
          activeGuide: '',
          activeList: '',
          activate_leave_plan_modal: false
        })
      }
    }
  }

  setActiveClass(guide, description) {
    if (Number(location.hash.substring(1) ) !== Number(guide.leave_item_id)) {
      this.handleBack({guide: guide, description: description})
    }
    $(window).scrollTop(0)
    this.setState({
      viewMode: true,
      activeGuide: guide,
      activeList: guide.id,
      description: description
    })
  }

  updateRecord(record) {
    this.setState({activeGuide: record})
    let planning_guides = this.state.planning_guides
    let index = ''
    $.each(planning_guides, (guide, ind) => {
      if (guide.id === parseInt(record.id)) {
        index = ind
        return false
      }
    })
    planning_guides[index] = record
    this.setState({planning_guides})
  }

  getAllData(e) {
    e.preventDefault()
    this.getInitialData()
    this.setState({
      viewMode: false,
      activeGuide: '',
      activeList: ''
    })
  }

  getInitialData() {
    $.getJSON('/leave_plan_guides', (data) => {
      this.setState({planning_guides: data})
    })
  }

  handleCheck(record) {
    let planning_guides = this.state.planning_guides
    let activeGuide = this.state.activeGuide
    const index = planning_guides.indexOf(activeGuide)
    activeGuide.timeline_items.map((item) => {
      if (item.id == parseInt(record.data.timeline_id)) {
        item.check_status = record.data.check_status
      }
      return item
    })
    planning_guides[index] = activeGuide
    this.setState({
      activeGuide: activeGuide,
      planning_guides: planning_guides
    })
  }

  onHelpfulCheck(data) {
    let guides = this.state.planning_guides
    $.each(guides, (i, guide) => {
      $.each(guide.timeline_items, (j, task) => {
        if (data.item_id === task.timeline_id) {
          task.helpful = data.helpful
          return false
        }
      })
    })
    this.setState({planning_guides: guides})
  }

  handleJustLookingClick(value) {
    this.setState({activate_leave_plan_modal: value})
  }

  onHelpfulCheckFromOutside(data) {
    let guides = this.state.planning_guides
    $.each(guides, (i, guide) => {
      if (data.item_id === guide.id) {
        guide.item.helpful = data.helpful
        return false
      }
    })
    this.setState({planning_guides: guides})
  }

  handleBackClick() {
    history.back()
  }

  renderItemList(guide, i) {
    return (
      <ItemList
        key={i}
        data={guide}
        handleOnClick={this.setActiveClass.bind(this)}
        activeList={this.state.activeList}
        controller_path='leave_plan_guides'
      />
    )
  }

  renderBody() {
    if (this.state.viewMode) {
      return (
        <ItemView
          data={this.state.activeGuide}
          updateRecord={this.updateRecord.bind(this)}
          associationUrl='leave_plan_guides/add_to_leave_plan'
          handleCheck={this.handleCheck.bind(this)}
          description={this.state.description}
          onHelpfulCheck={this.onHelpfulCheck.bind(this)}
          just_looking={this.props.just_looking}
          handleJustLookingClick={this.handleJustLookingClick.bind(this)}
          onHelpfulCheckFromOutside={this.onHelpfulCheckFromOutside.bind(this)}
          handleBackClick={this.handleBackClick.bind(this)}
          isLeavePlanPartner={this.props.isLeavePlanPartner}
        />
      )
    } else {
      return(<div className='row'>
        <div className='col-md-11 content-header'>
          <h2 className='leave-plan-guide-header'>
            Customize Your LeavePlan
          </h2>
          <div className='leave-plan-item-summary'>
            LeaveLogic Planning Guides include helpful information on topics related to your leave. You can easily add associated Tasks for the Planning Guides that interest you to further customize your LeavePlan.
          </div>
        </div>
        <ItemsListView
          data={this.state.planning_guides}
          handleOnClick={this.setActiveClass.bind(this)}
          item_link='leave_plan_guides'
        />
      </div>)
    }
  }

  renderJustLookingModal() {
    if (this.state.activate_leave_plan_modal) {
      return (
        <JustLookingModalBox
          handleJustLookingClose={this.handleJustLookingClick.bind(this)}
          infoTexts={this.infoTexts}
          buttons={
            {
              cancel: 'Later',
              confirm: 'Activate Now'
            }
          }
        />
      )
    }
  }

  render() {
    const { planning_guides } = this.state
    return (
      <div>
        <div id='sidebar-wrapper'>
          <div id='sidebar-content'>
            <div className='sidebar-elements'>
              <div className='all-benefits'>
                <a href='' onClick={this.getAllData.bind(this)}>
                  All Planning Guides
                </a>
              </div>
              <ul className='sidebar-nav'>
                {
                  planning_guides.map((guide, i) => this.renderItemList(guide, i))
                }
              </ul>
            </div>
            <WhiteLabel />
          </div>
        </div>
        <div id='page-content-wrapper'>
          <div className='page-content'>
            <div className='container-fluid'>
              <LeavePlanTitle
                title= {this.props.leave_plan_title}
                leave_plan_id= {this.props.leave_plan_id}
              />
              { planning_guides.length > 0 ? this.renderBody() : <h2>There are no Planning Guides for your current scenario.</h2> }
            </div>
          </div>
          <EmployeeFooter disclaimerText={this.props.disclaimer_text} />
        </div>
        { this.renderJustLookingModal() }
      </div>
    )
  }
}

export default PlanningGuides
